export const rules = {
  companyName: 'Company Name is required',
  message: 'Message is required',
  phoneNumber: 'Phone Number is required',
  invalidPhoneNumber: 'Phone number must be valid',
}
